import AskForLotsAndExpirationDatePanel from '../utils/panels/AskForLotsAndExpirationDatePanel';

function AskForLotsAndExpirationDateView() {
  return (
    <AskForLotsAndExpirationDatePanel />
  );
}

export default AskForLotsAndExpirationDateView;
